<div class="row page-header d-flex justify-content-center me-sm-1 ms-sm-1">
  <div class="col-12 col-lg-11 col-xl-10 max-900 row p-md-2 p-lg-0 p-0">
    <div class="col-lg-6 col-12 mt-sm-4 mb-sm-3 p-sm-0 ps-2">
      <h2 class="page-title oneLineTextHeader" i18n="Label users">
        {{ "clients" | transloco }} {{ "list" | transloco }}
      </h2>
    </div>
    @if (innerWidth > 1050) {
      <div
        [hidden]="innerWidth < 1050"
        class="col-6 mt-sm-4 mb-sm-3 p-0 d-flex justify-content-end"
        >
        <div class="d-flex">
          <a
            routerLink="/admin/clients/new"
            class="d-flex justify-content-center btn btn-lg orange-dark text-white"
            >
            <img src="assets/icons/icon-add.svg" alt="Add" />
            <span class="text-btn-add">{{ "add" | transloco }}</span>
          </a>
        </div>
      </div>
    }
    <div class="pe-1 ps-1 p-sm-0 d-flex justify-content-between">
      <app-search
        class="col-auto"
        style="min-width: 50%"
        (searchChange)="setFilter($event)"
      ></app-search>
      <app-sort-dropdown
        class="col-auto"
        [sortingOptions]="sortOptions"
        [sorting]="repo.sort$ | async"
        (sortingChange)="service.sort($event, searchFilter).subscribe()"
      ></app-sort-dropdown>
    </div>
    @if (repo.isLoading$ | async) {
      <app-spinner></app-spinner>
    }
    <div class="box mb-2 mt-3 m-0 p-0 row" style="width: 100%">
      <div class="box-name-header" style="width: 100%">
        <div class="mt-1 ms-1 row pt-1 m-0 p-0">
          <div class="col-sm-6 col-6 d-flex psm0">
            <input class="check form-check-input" type="checkbox" />
            <span class="txt mt-1 ms-2">{{ "name" | transloco }}</span>
          </div>
        </div>
      </div>
      <br />
      <ng-container *ngVar="repo.page$ | async as companies">
        @for (company of companies; track company) {
          <div
            class="row brd"
            style="margin-left: 0.1rem"
            >
            <div class="col-sm-8 col-12 pt-3 pb-3 d-flex align-items-center psm0">
              <input class="check form-check-input me-2" type="checkbox" />
              <div class="txt-name">
                <div
                  class="text-break oneLineText"
                  [routerLink]="['/admin/clients/', company.id]"
                  >
                  {{ company.title }}
                </div>
              </div>
            </div>
            @if (innerWidth > 575) {
              <div
                class="col-4 d-flex align-items-center justify-content-end p-0"
                >
                <div>
                  <a
                    class="btn btn-md btn-link w-100"
                    [routerLink]="['/admin/clients/contacts/', company.id]"
                    title="Contacts"
                    i18n-title="Contacts button"
                    >
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      >
                      <path
                        d="M7.38028 7.85323C8.07627 9.30285 9.02506 10.6615 10.2266 11.8631C11.4282 13.0646 12.7869 14.0134 14.2365 14.7094C14.3612 14.7693 14.4235 14.7992 14.5024 14.8222C14.7828 14.904 15.127 14.8453 15.3644 14.6752C15.4313 14.6274 15.4884 14.5702 15.6027 14.4559C15.9523 14.1063 16.1271 13.9315 16.3029 13.8172C16.9658 13.3862 17.8204 13.3862 18.4833 13.8172C18.6591 13.9315 18.8339 14.1063 19.1835 14.4559L19.3783 14.6508C19.9098 15.1822 20.1755 15.448 20.3198 15.7333C20.6069 16.3009 20.6069 16.9712 20.3198 17.5387C20.1755 17.8241 19.9098 18.0898 19.3783 18.6213L19.2207 18.7789C18.6911 19.3085 18.4263 19.5733 18.0662 19.7756C17.6667 20 17.0462 20.1614 16.588 20.16C16.1751 20.1588 15.8928 20.0787 15.3284 19.9185C12.295 19.0575 9.43264 17.433 7.04466 15.045C4.65668 12.6571 3.03221 9.79471 2.17124 6.76131C2.01103 6.19687 1.93092 5.91464 1.9297 5.5017C1.92833 5.04347 2.08969 4.42298 2.31411 4.02348C2.51636 3.66345 2.78117 3.39863 3.3108 2.86901L3.46843 2.71138C3.99987 2.17993 4.2656 1.91421 4.55098 1.76987C5.11854 1.4828 5.7888 1.4828 6.35636 1.76987C6.64174 1.91421 6.90747 2.17993 7.43891 2.71138L7.63378 2.90625C7.98338 3.25585 8.15819 3.43065 8.27247 3.60643C8.70347 4.26932 8.70347 5.1239 8.27247 5.78679C8.15819 5.96257 7.98338 6.13738 7.63378 6.48698C7.51947 6.60129 7.46231 6.65845 7.41447 6.72526C7.24446 6.96269 7.18576 7.30695 7.26748 7.5873C7.29048 7.6662 7.32041 7.72854 7.38028 7.85323Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                  <div>
                    <a
                      class="btn btn-md btn-link w-100"
                      [routerLink]="['/admin/clients/locations/', company.id]"
                      title="Locations"
                      i18n-title="Locations button"
                      >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 22 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                          d="M15 11.3744C18.5318 12.0688 21 13.6547 21 15.5C21 17.9853 16.5228 20 11 20C5.47715 20 1 17.9853 1 15.5C1 13.6547 3.46819 12.0688 7 11.3744M11 15V1L16.3177 4.27244C16.7056 4.51114 16.8995 4.63049 16.9614 4.78085C17.0154 4.912 17.0111 5.0599 16.9497 5.18771C16.8792 5.33426 16.6787 5.44222 16.2777 5.65815L11 8.5"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          />
                        </svg>
                      </a>
                    </div>
                    <div>
                      <a
                        class="btn btn-md btn-link w-100"
                        [routerLink]="['/admin/clients/', company.id]"
                        title="Edit"
                        i18n-title="Edit button"
                        >
                        <svg
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          >
                          <path
                            d="M1.39662 15.0963C1.43491 14.7517 1.45405 14.5794 1.50618 14.4184C1.55243 14.2755 1.61778 14.1396 1.70045 14.0142C1.79363 13.8729 1.91621 13.7503 2.16136 13.5052L13.1666 2.49992C14.0871 1.57945 15.5795 1.57945 16.4999 2.49993C17.4204 3.4204 17.4204 4.91279 16.4999 5.83326L5.49469 16.8385C5.24954 17.0836 5.12696 17.2062 4.98566 17.2994C4.86029 17.3821 4.72433 17.4474 4.58146 17.4937C4.42042 17.5458 4.24813 17.5649 3.90356 17.6032L1.08325 17.9166L1.39662 15.0963Z"
                            stroke="#475467"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            />
                          </svg>
                        </a>
                      </div>
                      <div>
                        <button
                          type="button"
                          class="btn btn-md btn-link w-100 text-danger"
                          data-bs-target="#deleteusermodal"
                          (click)="deleteConfirmation = company"
                          title="Delete"
                          i18n-title="Delete button"
                          >
                          <svg
                            width="18"
                            height="20"
                            viewBox="0 0 18 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                              d="M12.3333 5.00033V4.33366C12.3333 3.40024 12.3333 2.93353 12.1517 2.57701C11.9919 2.2634 11.7369 2.00844 11.4233 1.84865C11.0668 1.66699 10.6001 1.66699 9.66667 1.66699H8.33333C7.39991 1.66699 6.9332 1.66699 6.57668 1.84865C6.26308 2.00844 6.00811 2.2634 5.84832 2.57701C5.66667 2.93353 5.66667 3.40024 5.66667 4.33366V5.00033M7.33333 9.58366V13.7503M10.6667 9.58366V13.7503M1.5 5.00033H16.5M14.8333 5.00033V14.3337C14.8333 15.7338 14.8333 16.4339 14.5608 16.9686C14.3212 17.439 13.9387 17.8215 13.4683 18.0612C12.9335 18.3337 12.2335 18.3337 10.8333 18.3337H7.16667C5.76654 18.3337 5.06647 18.3337 4.53169 18.0612C4.06129 17.8215 3.67883 17.439 3.43915 16.9686C3.16667 16.4339 3.16667 15.7338 3.16667 14.3337V5.00033"
                              stroke="#475467"
                              stroke-width="1.66667"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                }
              </ng-container>
              <br />
              <div class="box-pagination-footer">
                <app-custom-pagination
                  [innerWidth]="innerWidth"
                  [page]="(repo.pageNumber$ | async) || 1"
                  [total]="(repo.paginationData$ | async)?.lastPage || 0"
          (pageChange)="
            service.loadFilterPage(searchFilter, $event).subscribe()
          "
                ></app-custom-pagination>
                @if (innerWidth < 1050) {
                  <div
                    class="w-100 d-flex justify-content-end add"
                    >
                    <a
                      routerLink="/admin/clients/new"
                      class="d-flex justify-content-center btn btn-lg orange-dark text-white"
                      >
                      <img src="assets/icons/icon-add.svg" alt="Add" />
                      <span class="text-btn-add" i18n="@@addCompany">{{
              "add" | transloco
            }}</span>
                    </a>
                  </div>
                }
              </div>
            </div>
            @if (deleteConfirmation) {
              <app-confirm-delete
                id="deleteusermodal"
                [deleteCandidate]="deleteConfirmation.title"
      (confirm)="
        handleDeleteClick(deleteConfirmation); deleteConfirmation = null
      "
                (cancel)="deleteConfirmation = null"
              ></app-confirm-delete>
            }
          </div>
        </div>
